import mixpanel from 'mixpanel-browser';
import { FC, useContext, useEffect } from 'react';
import MigrateAccountContext from '../../contexts/MigrateAccountContext';
import { EMixpanelEvent, ERoutes } from '../../util/constants';
import CreateAccountSuccess from '../CreateAccountSuccess/CreateAccountSuccess';

const MigrateAccountVerify: FC = () => {
    const { email, resendVerifyPasscode, submitVerifyPasscode } = useContext(MigrateAccountContext);

    useEffect(() => {
        mixpanel.track(EMixpanelEvent.actionStart, { key: 'verify_account' });
    }, []);

    return (
        <CreateAccountSuccess
            email={email}
            onResendPasscode={resendVerifyPasscode}
            onVerifyPasscode={submitVerifyPasscode}
            onVerifyRedirect={ERoutes.migrateAccountSuccess}
        />
    );
};

export default MigrateAccountVerify;
